/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DragHandleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Drag Handle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="14" cy="26" r="2" />
    <circle cx="14" cy="20" r="2" />
    <circle cx="14" cy="14" r="2" />
    <circle cx="14" cy="8" r="2" />
    <circle cx="20" cy="26" r="2" />
    <circle cx="20" cy="20" r="2" />
    <circle cx="20" cy="14" r="2" />
    <circle cx="20" cy="8" r="2" />
  </svg>`;
};
